"use client";

import { useSession } from "next-auth/react";
import { usePathname } from "next/navigation";
import { AgentSidebar } from "./AgentSidebar";
import { AgentFAB } from "./AgentFAB";

/**
 * AgentProvider - Renders the Agent FAB and Sidebar on authenticated pages
 *
 * This component should be added to the providers or layout to make the
 * agent accessible from any page. Only admin users can see the agent UI.
 */
export function AgentProvider() {
  const { status, data: session } = useSession();
  const pathname = usePathname();

  // Suppress on the public fideo marketing surface — no chrome on public pages.
  if (pathname?.startsWith("/fideo")) {
    return null;
  }

  // Only show agent UI for authenticated admin users
  if (status !== "authenticated") {
    return null;
  }

  // Check if user is an admin (set in session by NextAuth callbacks)
  if (!session?.user?.isAdmin) {
    return null;
  }

  return (
    <>
      <AgentFAB />
      <AgentSidebar />
    </>
  );
}
